import { createRootRoute, Outlet } from "@tanstack/react-router";

import { MaybeDevTools } from "../components/MaybeDevtools";
import { Navigation } from "../components/Navigation";
import { AuthProvider } from "../context/auth";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <AuthProvider>
      <div className="min-h-screen flex flex-col">
        <Navigation />
        <div className="flex-1 flex flex-col pt-6">
          <Outlet />
        </div>
      </div>
      <MaybeDevTools />
    </AuthProvider>
  );
}
